/*************************
  🚨 Auto-generated file. Do not modify directly!
  🚨 Instead, modify ./svg-template.ts or the SVG file
  🚨 See packages/bundler for more info
*************************/
import * as React from 'react';
import type { SVGIconProps } from '../types';
export function Type({
  className,
  size,
  style
}: SVGIconProps) {
  const props = {
    preserveAspectRatio: 'xMidYMid meet',
    className,
    style: {
      verticalAlign: 'middle',
      ...style
    },
    width: size ?? '1em',
    height: size ?? '1em'
  };
  return <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 16 16" {...props}><path fill="currentColor" fillRule="evenodd" d="M2.4 3.5c0-1.16.94-2.1 2.1-2.1h7c1.16 0 2.1.94 2.1 2.1V5a.6.6 0 1 1-1.2 0V3.5a.9.9 0 0 0-.9-.9H8.6v10.8H10a.6.6 0 1 1 0 1.2H6a.6.6 0 0 1 0-1.2h1.4V2.6H4.5a.9.9 0 0 0-.9.9V5a.6.6 0 0 1-1.2 0V3.5Z" clipRule="evenodd" /></svg>;
}
;